import * as React from 'react';
import FeatureFlagsHeader from './FeatureFlags/FeatureFlagsHeader';
import FeatureFlagsList from './FeatureFlags/FeatureFlagsList';
import HeaderFlexPane from './HeaderFlexPane';
import HeaderPaneProps from './HeaderPaneProps';

const FeatureFlagsPane: React.SFC<HeaderPaneProps> = props => {
    return (
        <HeaderFlexPane
            title="Feature Flags"
            content={
                <div>
                    <FeatureFlagsHeader />
                    <FeatureFlagsList />
                </div>
            }
            onDismiss={props.onDismiss}
        />
    );
};

export default FeatureFlagsPane;
